// Device tag ids pasted as free text: separated by new lines, commas, semicolons or spaces.
export function parseTagIds(text) {
    return clean((text || '').split(/[\s,;]+/));
}

// Device tag ids from a .csv or .txt file: the first column of each line, skipping a header row.
export function parseTagIdFile(text) {
    const firstColumns = (text || '')
        .replace(/^\uFEFF/, '')
        .split(/\r?\n/)
        .map(line => line.split(/[,;\t]/)[0].replace(/["']/g, ''));
    // Tag ids always contain digits, so a first line without any is a header
    if (firstColumns.length > 0 && !/\d/.test(firstColumns[0])) {
        firstColumns.shift();
    }
    return clean(firstColumns);
}

function clean(values) {
    const tagIds = values.map(value => value.trim()).filter(value => value);
    const ids = [...new Set(tagIds)];
    return { ids: ids, duplicateCount: tagIds.length - ids.length };
}
